import { mapGetters } from 'vuex';
import "core-js/modules/es.array.push.js";
import { defineComponent } from 'vue';
import Title from './title.vue';
export default defineComponent({
  name: 'technologies',
  data() {
    return {
      list: [{
        title: 'AI makes <br>creativity simpler',
        class: 'fir',
        subtitle: "No Design Experience Needed，AI helps you effortlessly transform your pet's moments into beautiful works of art."
      }, {
        title: 'Custom <br>Pet Merchandise',
        class: 'sec',
        subtitle: 'Customize your own 3D-printed Pet Portrait Canvas, keychains, or personalized figurines—perfect for placing anywhere you like.'
      }, {
        title: 'Simple & Easy, <br>No Expertise Needed',
        class: 'thr',
        subtitle: 'Just upload a photo, generate the model, and submit for printing. PetPat 3D handles the tech, while creativity is all yours!'
      }]
    };
  },
  components: {
    Title
  },
  computed: {
    ...mapGetters('userInfo', ['isLogin'])
  },
  methods: {
    goEditor() {
      if (this.isLogin) {
        this.$router.push('/edit-project');
      } else {
        this.$store.commit('userInfo/setOpenLoginPanel', true);
      }
    }
  }
});